import { useCallback, useState } from 'react';
import { useLinkTo } from '../../../../../hooks';
import analytics from '../../../../../modules/analytics';
import { SearchSubmitter } from '../../../search/SearchPopover/types';
import { SEARCH_ROUTE } from '../../../../../route-names';

/**
 * Note: This hook is only in place to continue supporting the
 * incentives search popover for referrals behavior. Search for
 * `useIncentivesPopovers` in the codebase to see where this is
 */
export const useIncentivesPopovers = () => {
  const linkTo = useLinkTo();
  // State variables
  const [
    isIncentivesSearchOpen,
    setIncentivesSearchOpen,
  ] = useState<boolean>(false);

  // Callbacks
  const handleIncentivesSearchSubmitted = useCallback<SearchSubmitter>((
    query: string,
    _,
    slugged,
  ) => {
    analytics.track('client_proprofile_idle_incentives_search_offers_searched', {
      query,
    });
    setIncentivesSearchOpen(false);
    linkTo(SEARCH_ROUTE, slugged);
  }, [linkTo]);

  const handleIncentivesSearchDismissed = useCallback(() => {
    setIncentivesSearchOpen(false);
    analytics.track('client_proprofile_idle_incentives_search_offers_dismissed');
  }, []);

  return {
    isIncentivesSearchOpen,
    setIncentivesSearchOpen,
    handleIncentivesSearchSubmitted,
    handleIncentivesSearchDismissed,
  };
};
